import supportedFileExtensions from "../components/Test/QuestionAnswerType/supportedFileExtensions";

// Questions where the candidate needs headphones, so the proctoring object check must not flag
// headphones/neckbands (phones are still flagged): video interview (27), speaking questions
// (SpeechEvaluation 23/31, AutoSpeech 28), and any question with an audio clip to listen to.
const HEADPHONE_QUESTION_TYPES = ["23", "27", "28", "31"];

// Resource fields hold one or more paths/URLs joined by "|^^|" or "|" (e.g. qresourcepath,
// passageImage, chresourcepath, blank options). True if any of them is an audio file, using the
// same extension list the question components use to decide to render an <audio> player.
const hasAudioFile = (value) =>
  typeof value === "string" &&
  value.split(/\|\^\^\||\|/).some((part) => {
    const path = part.trim().split("?")[0];
    const dot = path.lastIndexOf(".");
    return dot > 0 && supportedFileExtensions.audio.includes(path.slice(dot + 1).toLowerCase());
  });

export const questionAllowsHeadphones = (question) =>
  !!question &&
  (HEADPHONE_QUESTION_TYPES.includes(String(question.qtypecode)) || Object.values(question).some(hasAudioFile));

// Which audio proctoring checks run for the question on screen (BackgroundAudioRecorder):
// - "skip": speaking/speech-evaluation questions (23/28/31) and questions with an audio clip -
//   the candidate repeats or answers what's played, so no audio is sent at all.
// - "speakersOnly": a video-interview question (27) while recording - speaking is the answer,
//   but a second voice (someone, or an AI reading the answer aloud) is still caught.
// - "videoQuestion": a video-interview question when not recording (before Record, or after Stop
//   while the answer uploads). Candidates naturally talk there, so no "don't talk" reminder - but
//   reading the question aloud (e.g. to an AI) is still proven from the transcript and warned,
//   and a second voice is still caught.
// - "full": everything else.
const SPEAKING_QUESTION_TYPES = ["23", "28", "31"];

export const audioCheckMode = (question, isRecording) => {
  if (!question) return "full";
  const type = String(question.qtypecode);
  if (SPEAKING_QUESTION_TYPES.includes(type) || Object.values(question).some(hasAudioFile)) return "skip";
  if (type === "27") return isRecording ? "speakersOnly" : "videoQuestion";
  return "full";
};
